import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './components/Header/header';
import Footer from './components/Footer/footer';
import './styles/_index.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import CookieConsent from './components/CookieConsent/CookieConsent';
import AdComponent from './AdComponent';
import NewsPage from './pages/NewsPage/newsPage';

import { useDispatch } from "react-redux";
import { setUser } from './features/auth/authSlice';
import { useEffect } from "react";

import { NotificationSocketProvider } from './contexts/NotificationSocketProvider';
import { Toaster } from 'react-hot-toast';

// Lazy load components
//const NewsPage = lazy(() => import('./pages/NewsPage/newsPage'));
const HomePage = lazy(() => import('./pages/HomePage/homePage'));
const BookshelfPage = lazy(() => import('./pages/BookshelfPage/bookshelfPage'));
const LoginPage = lazy(() => import('./pages/LoginPage/loginpage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage/registerPage'));
const UserProfilePage = lazy(() => import('./pages/UserProfilePage/userprofilePage'));
const BookDetailPage = lazy(() => import('./pages/BookDetailPage/BookDetailPage'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword/Forgotpassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword/ResetPassword'));

const TermsPage = lazy(() => import('./pages/TermsPage/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage/PrivacyPage'));

function App() {
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem("user"));
    if (storedUser) {
      dispatch(setUser(storedUser)); // Update Redux state
    }
  }, [dispatch]);

  
  return (
    <NotificationSocketProvider>
      <Toaster position="top-right" />
    <Router>
       

      <div className="App">
        
        <Header />
        <div style={{ textAlign: "center", margin: "20px 0" }}>
  <AdComponent />
</div>
        <CookieConsent />
      
        <main className="center-section">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/bookshelf" element={user ? <BookshelfPage /> : <Navigate to="/login" replace />} />
              <Route path="/books/:id" element={<BookDetailPage />} /> 
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profile/:userId" element={<UserProfilePage />} /> 
              <Route path="/profile" element={<UserProfilePage />} /> 
              <Route path="/book/:bookId" element={<BookDetailPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="*" element={<Navigate to="/" />} />

            </Routes>
          </Suspense>
        </main>
        </div>
        <Footer />
            

    </Router>
    </NotificationSocketProvider>

  );
}

export default App;
